import { isIPad13, isMobile } from 'mobile-device-detect';

export const METAMASK_INSTALL_URL = 'https://metamask.io/download/';

export const isMobileDevice = (): boolean => isMobile || isIPad13;

export const buildMetaMaskDeepLink = (): string => {
    const { host, pathname, search } = window.location;

    return `https://metamask.app.link/dapp/${host}${pathname}${search}`;
};
